import gql from "graphql-tag";

export const UserInfoFragment = gql`
  fragment UserInfo on CompanyUser {
    company_user_email
    company_user_firstname
    company_user_lastname
    company_user_clientId
    company_user_phone_number
    _id
    company_user_profil
    company_user_job
    company_user_created_at
    company_user_profil
    company_user_picture_url
    company_user_last_active
    compnay_user_client {
      client_company_name
    }
  }
`;

export const ClientFragment = gql`
  fragment ClientInfo on Client {
    client_UID
    _id
    client_email
    client_contact_email
    client_company_name
    client_ninea_url
    client_activity
    client_contact_job
    client_phone_number
    client_address {
      address
    }
    client_company_users {
      ...UserInfo
    }
  }
  ${UserInfoFragment}
`;
